import React from 'react';
import DlpCards from './DlpCards'
import './dlp.css'

const DlpDemo = () => {

  const url = new URL(window.location.href);

  return (
    <>
      <div className='dlp-page w-100 py-3' style={{ overflowX: 'hidden' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={() => window.location.href = `${url.origin}/demo`}>
            <span className="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back to main page</p>
          </div>
        </div>

        <div className='px-sm-5 px-3 mt-3 mb-5'>
          <DlpCards />
        </div>
      </div>
    </>
  )
}

export default DlpDemo
